import { render, staticRenderFns } from "./App.vue?vue&type=template&id=38c2a5c0&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=38c2a5c0&prod&lang=scss&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=38c2a5c0&prod&lang=scss&scoped=true&"
import style2 from "./App.vue?vue&type=style&index=2&id=38c2a5c0&prod&lang=scss&"
import style3 from "./App.vue?vue&type=style&index=3&id=38c2a5c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2a5c0",
  null
  
)

export default component.exports